import { CHESS_PHASE_TICKS, PHASE_TRANSITION_TICKS, SHOOTER_PHASE_TICKS } from './constants';
import { cloneState, resetShooter } from './state';
import type { PlayerId, State } from './types';

// The match state machine: phases and the end of the match. Physics, weapons and the board live elsewhere.

/** Forfeiting ends the whole match; an existing result cannot be changed. */
export function forfeitMatch(state: State, player: PlayerId): State {
  const s = cloneState(state);
  if (s.winner === null) s.winner = player === 0 ? 1 : 0;
  return s;
}

/**
 * Switches phases at their tick boundaries: arena → board → arena → … Leaving the arena clears
 * everything in flight. Returning to the arena rebuilds it while preserving the board and clocks.
 * The target phase starts after the frozen transition ticks handled by step().
 */
export function stepPhase(s: State): void {
  if (s.transitionTicks > 0 || s.tick < s.phaseEndsAtTick) return;
  s.transitionTicks = PHASE_TRANSITION_TICKS;
  if (s.phase === 'shooter') {
    s.phase = 'chess';
    s.npcBoxes = [];
    s.npcs = [];
    s.phaseEndsAtTick = s.tick + CHESS_PHASE_TICKS;
    s.projectiles = [];
    s.bursts = [];
    s.beams = [];
    s.blasts = [];
    s.chess.lastMoveTick = s.tick;
  }
  if (s.phase === 'chess' && s.tick >= s.phaseEndsAtTick) {
    resetShooter(s);
    s.phase = 'shooter';
    s.phaseEndsAtTick = s.tick + SHOOTER_PHASE_TICKS;
  }
}

/**
 * Ends the match on an empty chess clock, in either phase (hits drain it in the arena, thinking at
 * the board); both empty in the same tick is a draw. The board's own endings (mate, stalemate,
 * material) are set by applyChessMove and take precedence because they come first in the tick.
 */
export function stepMatchEnd(s: State): void {
  if (s.winner !== null) return;
  const out0 = s.players[0].chessClockMs <= 0;
  const out1 = s.players[1].chessClockMs <= 0;
  if (!out0 && !out1) return;
  s.winner = out0 && out1 ? 'draw' : out0 ? 1 : 0;
  s.outcome = 'clock';
}
